/* Afkar Plus — collection shelf: dot pager + quantity steppers that add straight to the cart (BeyondADS, 23 Sep 2026) */
(function () {
  'use strict';
  if (window.__afsLoaded) return;
  window.__afsLoaded = true;

  var routes = window.routes || {};
  var ADD = (routes.cart_add_url || '/cart/add') + '.js';
  var CHANGE = (routes.cart_change_url || '/cart/change') + '.js';
  var CART = (routes.cart_url || '/cart') + '.js';

  /* ---------- dot pager ---------- */
  function initPager(root) {
    var track = root.querySelector('[data-afs-track]');
    var dotsBox = root.querySelector('[data-afs-dots]');
    if (!track || !dotsBox) return;
    var cards = track.querySelectorAll('[data-afs-card]');
    if (!cards.length) return;
    var pages = 1, step = 0, settle = null;

    function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function measure() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var cw = cards[0].getBoundingClientRect().width;
      var perView = Math.max(1, Math.round((track.clientWidth + gap) / (cw + gap)));
      step = perView * (cw + gap);
      pages = Math.max(1, Math.ceil(cards.length / perView));
      build();
    }
    function build() {
      dotsBox.innerHTML = '';
      dotsBox.hidden = pages < 2;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'afs-dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Page ' + (i + 1) + ' of ' + pages);
        b.setAttribute('data-page', i);
        dotsBox.appendChild(b);
      }
      mark();
    }
    function current() {
      if (!step) return 0;
      if (track.scrollLeft >= maxScroll() - 2) return pages - 1;
      return Math.min(pages - 1, Math.round(track.scrollLeft / step));
    }
    function mark(force) {
      var c = typeof force === 'number' ? force : current();
      var dots = dotsBox.querySelectorAll('.afs-dot');
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === c);
        dots[i].setAttribute('aria-selected', i === c ? 'true' : 'false');
      }
    }
    function go(p) {
      p = Math.max(0, Math.min(pages - 1, p));
      track.scrollTo({ left: Math.min(maxScroll(), p * step), behavior: 'smooth' });
      mark(p); /* instant feedback; the scroll listener re-syncs once the scroll settles */
    }
    dotsBox.addEventListener('click', function (e) {
      var d = e.target.closest('.afs-dot');
      if (d) go(parseInt(d.getAttribute('data-page'), 10) || 0);
    });
    track.addEventListener('scroll', function () {
      mark();
      clearTimeout(settle);
      settle = setTimeout(mark, 120);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    var rt = null;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
    measure();
    root.__afsGo = go;
  }

  /* ---------- quantity steppers ---------- */
  function initQty(root) {
    var boxes = root.querySelectorAll('[data-afs-qty]');
    if (!boxes.length) return;

    function setN(box, n) {
      box.querySelector('[data-afs-n]').textContent = n;
      box.classList.toggle('has-items', n > 0);
    }
    function note(box, text) {
      var msg = box.parentNode.querySelector('[data-afs-msg]');
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
      if (text) setTimeout(function () { msg.hidden = true; }, 4000);
    }
    function paintBubble(sections) {
      var html = sections && sections['cart-icon-bubble'];
      var el = document.getElementById('cart-icon-bubble');
      if (!html || !el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('.shopify-section');
      el.innerHTML = inner ? inner.innerHTML : html;
    }
    function syncFromCart() {
      return fetch(CART, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var counts = {};
          (cart.items || []).forEach(function (it) { counts[it.variant_id] = (counts[it.variant_id] || 0) + it.quantity; });
          for (var i = 0; i < boxes.length; i++) setN(boxes[i], counts[boxes[i].getAttribute('data-variant')] || 0);
          return cart;
        });
    }

    syncFromCart().catch(function () {});

    root.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-afs-plus]');
      var minus = e.target.closest('[data-afs-minus]');
      if (!plus && !minus) return;
      var box = e.target.closest('[data-afs-qty]');
      if (!box || box.classList.contains('is-busy')) return;
      var id = parseInt(box.getAttribute('data-variant'), 10);
      var n = parseInt(box.querySelector('[data-afs-n]').textContent, 10) || 0;
      var next = plus ? n + 1 : Math.max(0, n - 1);
      if (next === n) return;
      box.classList.add('is-busy');
      note(box, '');
      var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var req = plus
        ? fetch(ADD, { method: 'POST', headers: headers, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: 'cart-icon-bubble' }) })
        : fetch(CHANGE, { method: 'POST', headers: headers, body: JSON.stringify({ id: String(id), quantity: next, sections: 'cart-icon-bubble' }) });
      req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'Could not update the cart');
          paintBubble(res.body && res.body.sections);
          document.dispatchEvent(new CustomEvent('afkar:cart:updated', { detail: { variant: id } }));
          return syncFromCart();
        })
        .catch(function (err) { note(box, err && err.message ? err.message : 'Could not update the cart'); })
        .then(function () { box.classList.remove('is-busy'); });
    });
  }

  function init(root) {
    if (root.__afs) return;
    root.__afs = true;
    initPager(root);
    initQty(root);
  }
  function boot() { document.querySelectorAll('[data-afs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
